module.exports = "/images/vendor/flag-icon-css/flags/1x1/si.svg?63ba8c45578b45c1e1db541ff44fb1fd";